import jwt_decode from 'jwt-decode';
import { AppConfig } from '../../app.config';
import { Role } from '../../types/role';

const getCookie = (cookieName: string): string | undefined => {
  return document.cookie.split(`; `).find((cookie) => cookie.includes(cookieName));
};

export type transferToken = decodedToken & encodedToken;

interface decodedToken {
  token: string;
  dealerPublicId: string;
  targetUi: string;
  idvType: IDVType;
  customerId?: number;
  phoneNumber: string;
  applicationId?: number;
  exp: number;
}

enum IDVType {
  Full = 'Full', // Full" represents both OTP and last 4 + DOB check
  OTP = 'OTP',
}

interface encodedToken {
  token: string;
}

const tokenCookieName = 'unifiedSecurityToken';
export const getUnifiedToken = (): transferToken | null => {
  const matchedCookie = getCookie(tokenCookieName);
  if (matchedCookie) {
    const tokenCookie = matchedCookie.split('=') as [string, string];
    if (tokenCookie[0] === tokenCookieName) {
      try {
        let unifiedToken = jwt_decode(tokenCookie[1]) as transferToken;
        unifiedToken.token = tokenCookie[1];
        return unifiedToken;
      } catch (err) {
        // TOOD: remove this
        console.log('Could not verify token', err);
      }
    }
  }
  return null;
};

// cookie name is dealer.ENVIRONMENT.koalafi.com.AspNet.JwtCookies
// QA environments use just qa instead of dealer1/dealer2/dealer3
const dealerPortalUrl = AppConfig.dealerPortalUrl.replace('https://', '').replace(/dealer\d/, 'dealer');
const dealerCookieSuffix = '.AspNet.JwtCookies';
const roleKey = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

export const getDealerCookie = (): Role | null => {
  const dealerCookie = getCookie(dealerPortalUrl + dealerCookieSuffix);
  if (dealerCookie) {
    try {
      const cookieValue = dealerCookie.split('=') as [string, string];
      const decodedToken = jwt_decode(cookieValue[1]) as any;

      if (decodedToken && decodedToken[roleKey]) {
        const role = decodedToken[roleKey];
        return Array.isArray(role) ? role[0] : role;
      }
    } catch (err) {
      // TOOD: remove this
      console.log('Could not verify token', err);
    }
  }
  return null;
};
